import { IMarketingCenterTemplate } from '@/models/marketingCenter/template';
import {
  TitleCanvasElement,
  BackgroundImageCanvasElement,
  TextCanvasElement,
  VerticalTextWrapper,
  BrandCanvasElement
} from '@/models/marketingCenter/elements';
import {
  InstagramPostFormat,
  InstagramStoryFormat,
  FacebookPostFormat
} from '@/models/marketingCenter/formats';
import { EMarketingCenterColorSchemes } from '../colorScheme';

const OfferTemplate: IMarketingCenterTemplate = {
  tag: 'Offers',
  title: 'Offer Post',
  description:
    'Announce to your members an exclusive Offer for those using the app.',
  disabledDescription:
    'To create an Offer Post, first you will need to create at least one Offer.',
  button: {
    label: 'Create an Offer',
    link: '/special-coins-offers/create'
  },
  placeholders: {
    title: '20% off storewide for today only!',
    text: 'Get offer!',
    colorScheme: EMarketingCenterColorSchemes.PURPLE,
    titleMaxLength: 35
  },
  form: {
    hideMessageField: true
  },
  formats: [
    new InstagramStoryFormat([
      new BackgroundImageCanvasElement({
        image: 'marketingCenter/canvas/offer/instagram-story.png'
      }),
      new BrandCanvasElement({
        width: 64,
        height: 64,
        x: 98,
        y: 81,
        radius: 32,
        borderWidth: 2
      }),
      new TitleCanvasElement({
        font: {
          size: 28,
          weight: 'bold',
          lineHeight: 28,
          maxWidth: 153,
          align: 'center',
          numberOfLines: 5
        },
        position: {
          x: 53,
          y: 178
        }
      }),
      new TextCanvasElement({
        font: {
          size: 13,
          weight: 'bold',
          lineHeight: 13
        },
        position: {
          x: 95,
          y: 358
        },
        text: 'Get Offer!'
      })
    ]),
    new InstagramPostFormat([
      new BackgroundImageCanvasElement({
        image: 'marketingCenter/canvas/offer/instagram-post.png'
      }),
      new BrandCanvasElement({
        width: 46,
        height: 46,
        x: 105,
        y: 66,
        radius: 23,
        borderWidth: 2
      }),
      new TitleCanvasElement({
        font: {
          size: 23,
          weight: 'bold',
          lineHeight: 23,
          maxWidth: 166,
          align: 'center',
          numberOfLines: 3
        },
        position: {
          x: 46,
          y: 119
        }
      }),
      new TextCanvasElement({
        font: {
          size: 11,
          weight: 'bold',
          lineHeight: 11
        },
        position: {
          x: 100,
          y: 211
        },
        text: 'Get Offer!'
      })
    ]),
    new FacebookPostFormat([
      new BackgroundImageCanvasElement({
        image: 'marketingCenter/canvas/offer/facebook-post.png'
      }),
      new BrandCanvasElement({
        width: 48,
        height: 48,
        x: 50,
        y: 40,
        radius: 24,
        borderWidth: 2
      }),
      new TitleCanvasElement({
        font: {
          size: 17,
          weight: 'bold',
          lineHeight: 17,
          maxWidth: 93,
          align: 'center',
          numberOfLines: 5
        },
        position: {
          x: 144,
          y: 35
        }
      }),
      new TextCanvasElement({
        font: {
          size: 10,
          weight: 'bold'
        },
        position: {
          x: 50,
          y: 104
        },
        text: 'Get Offer!'
      })
    ])
  ]
};

export default OfferTemplate;
